// src/pages/About.js
import React, { useState } from "react";
import "./About.css";
import AboutPopUp from "../AboutPopUp";

function About() {
  const [popupData, setPopupData] = useState(null);

  const processData = [
    {
      id: 1,
      title: "Recycled, Liquidation & New Turf Supply",
      content:
        "Calimesa Turf Center specializes in recycled, liquidation, and new artificial turf rolls. We source stadium-grade and premium quality turf, carefully inspected and organized so homeowners and contractors can choose the right product for their project and budget.",
      videoIndex: 1,
    },
    {
      id: 2,
      title: "Licensed C-27 Landscape Design & Consultation",
      content:
        "Under Graystone Construction (DBA Graystone Enterprises Inc.), our Licensed C-27 Landscape Contractors design complete outdoor spaces — from front yards and backyards to commercial plazas. We provide site walks, measurements, and custom design recommendations to match your vision.",
      videoIndex: 2,
    },
    {
      id: 3,
      title: "Professional Installation & Project Management",
      content:
        "Our team handles the full installation process: demolition, grading, base prep, compaction, drainage considerations, turf installation, and finishing details. We coordinate each phase with clear timelines so you always know what is happening on your project.",
      videoIndex: 3,
    },
    {
      id: 4,
      title: "DIY Support & Contractor Turf Pickup",
      content:
        "If you prefer to do the work yourself or you are a licensed contractor, we offer appointment-based turf pickup in Calimesa. Recycled turf can be heavy, so a suitable truck or trailer is required. Our team helps you review and select rolls on-site before loading.",
      videoIndex: 4,
    },
    {
      id: 5,
      title: "Licensed Home Improvement Sales (HIS)",
      content:
        "Our Home Improvement Salespersons (HIS) are licensed with the California Contractors State License Board (CSLB). They are trained to provide clear estimates, explain contracts, and make sure your project is properly documented and compliant with California regulations.",
      videoIndex: 5,
    },
    {
      id: 6,
      title: "Bonded, Insured & Contractor Discounts",
      content:
        "Graystone Construction is bonded and insured to cover projects of all sizes. Licensed contractors with an ACTIVE CSLB license can present their license at pickup to receive a 5% discount on recycled turf, subject to current inventory and availability.",
      videoIndex: 6,
    },
  ];

  const openPopup = (item) => setPopupData(item);
  const closePopup = () => setPopupData(null);

  return (
    <div className="about-page">
      <div className="about-container">
        <h1>About Calimesa Turf Center & Graystone Construction</h1>
        <p>
          At <strong>Calimesa Turf Center</strong>, powered by <strong>Graystone Construction (DBA Graystone Enterprises Inc.)</strong>, our mission is to make professional-quality artificial turf and landscape design accessible to homeowners and contractors across California. As Licensed C-27 Landscape Contractors with licensed Home Improvement Salespersons (HIS), we combine field experience, technical knowledge, and genuine customer care on every project.
        </p>

        <h2>Our Services & Process</h2>
        <p>Explore how we help you choose the right turf, design your outdoor space, and complete your project from start to finish:</p>
        <ul className="process-list">
          {processData.map((item) => (
            <li key={item.id} onClick={() => openPopup(item)}>
              <strong>{item.title}:</strong> {item.content.substring(0, 80)}...
            </li>
          ))}
        </ul>

        <h2>Our Commitment</h2>
        <p>
          At <strong>Calimesa Turf Center</strong>, we prioritize honesty, craftsmanship, and long-term results. Every estimate is designed to be clear and transparent, and every installation is built to last — from the base material beneath your turf to the final cut along your borders. Whether you are a homeowner planning your first turf project or a licensed contractor looking for a reliable turf partner, you receive the same level of professional support and respect.
        </p>
      </div>

      {popupData && (
        <AboutPopUp
          onClose={closePopup}
          title={popupData.title}
          content={popupData.content}
          videoIndex={popupData.videoIndex}
        />
      )}
    </div>
  );
}

export default About;